// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1873":"css/app.6760","6538":"css/admin-app.6760"}[chunkId] + ".css";
};